import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initAppLogCapture } from '@/utils/appLogCapture'

initAppLogCapture();
createRoot(document.getElementById("root")!).render(<App />);
